import { render, staticRenderFns } from "./stockX10.vue?vue&type=template&id=71090a58&scoped=true&"
import script from "./stockX10.vue?vue&type=script&lang=js&"
export * from "./stockX10.vue?vue&type=script&lang=js&"
import style0 from "./stockX10.vue?vue&type=style&index=0&id=71090a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71090a58",
  null
  
)

export default component.exports